import { render } from "./PushNotificationActivator.vue?vue&type=template&id=d70f3ffe"
import script from "./PushNotificationActivator.vue?vue&type=script&lang=js"
export * from "./PushNotificationActivator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__